<!--
 * @Author: your name
 * @Date: 2022-04-26 17:14:05
 * @LastEditTime: 2022-10-09 10:47:56
 * @LastEditors: shijian.chen shijian.chen@qunar.com
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /dmf_ad_currency_h5/src/views/modules/volvo202204/index.vue
-->
<template>
  <div id="main">
    <div class="top">
      <a href="/currency/#/volvo202207">
        <img
          src="https://source.qunarzz.com/site/images/wns/20220915-shijianchen-tp.png"
          class="top-f1"
          alt=""
        />
      </a>
      <div class="video">
        <videoComp
          :auto="true"
          id="video001"
          src="https://source.qunarzz.com/site/images/wns/20220921-shijianchen-vol-video.mp4"
        ></videoComp>
      </div>
      <img
        class="route"
        src="https://source.qunarzz.com/site/images/wns/20220916-shijianchen-3.png"
        alt=""
      />
    </div>
    <div class="center">
      <div class="special">
        <div class="swiper-container">
          <div class="swiper-wrapper">
            <div
              class="swiper-slide"
              v-for="(item, index) in imgs"
              :key="index"
            >
              <img :src="item" alt="" />
            </div>
          </div>
        </div>
      </div>
      <div class="video2">
        <div class="swiper-container2">
          <div class="swiper-wrapper">
            <div
              class="swiper-slide"
              v-for="(item, index) in imgs2"
              :key="index"
            >
              <img :src="item" alt="" />
            </div>
          </div>
        </div>
      </div>
      <!-- <a
        class="line lineTop"
        v-maidian="'neimeng'"
        href="https://touch.dujia.qunar.com/p/item/2160461405"
        ><img
          src="https://source.qunarzz.com/site/images/wns/20220712-shijianchen-vol-line1.png"
          alt=""
      /></a> -->
      <div class="lineList1">
        <line-comp :lineList="lineList1"></line-comp>
      </div>
      <div class="box">
        <img
          src="https://source.qunarzz.com/site/images/wns/20220712-shijianchen-vol-tit1.jpg"
          alt=""
        />
        <line-comp :lineList="lineList2" :showMore="lookMore"></line-comp>
        <img
          v-if="!lookMore"
          @click="
            () => {
              lookMore = true;
            }
          "
          class="lookMore"
          src="https://source.qunarzz.com/site/images/wns/20220712-shijianchen-vol-lookmore.png"
          alt=""
        />
      </div>
      <img
        class="tit"
        src="https://source.qunarzz.com/site/images/wns/20220712-shijianchen-vol-title1.png"
        alt=""
      />
      <mt-swipe :auto="0" class="swipeWrapper" ref="swipeWrapper">
        <img
          @click="prev"
          src="https://source.qunarzz.com/site/images/wns/20220922-shijianchen-arrlf.png"
          class="left"
          alt=""
        />
        <img
          @click="next"
          src="https://source.qunarzz.com/site/images/wns/20220922-shijianchen-arrrt.png"
          class="right"
          alt=""
        />
        <mt-swipe-item>
          <div class="video3">
            <videoComp
              :type="'nobg'"
              src="https://source.qunarzz.com/site/images/wns/20220928-shijianchen-video.mp4"
              poster="https://source.qunarzz.com/site/images/wns/20220929-shijianchen-poster.png"
            ></videoComp>
          </div>
          <a
            v-maidian="'note2'"
            class="note"
            href="http://travel.qunar.com/travelbook/note/7753389"
          >
            <img
              class="note-lf"
              src="https://source.qunarzz.com/site/images/wns/20220923-shijianchen-note-1.jpg"
              alt=""
            />
            <div class="note-rt">
              <div class="note-box">
                <img
                  class="note-logo"
                  src="https://source.qunarzz.com/site/images/wns/20220923-shijianchen-note-2.png"
                  alt=""
                />
                <div>
                  <div class="undeline">
                    大美腾冲，极边之城的秘境之旅与奢享体验
                  </div>
                  <p>@潘小七的潘同学</p>
                </div>
              </div>
            </div>
          </a>
        </mt-swipe-item>
        <mt-swipe-item>
          <div class="video3">
            <videoComp
              :type="'nobg'"
              src="https://source.qunarzz.com/site/images/wns/20220921-shijianchen-1.mp4"
              poster="https://source.qunarzz.com/site/images/wns/20220921-shijianchen-poster5.jpeg"
            ></videoComp>
          </div>
          <a
            v-maidian="'note'"
            class="note"
            href="http://travel.qunar.com/travelbook/note/7753016"
          >
            <!-- <img
          src="https://source.qunarzz.com/site/images/wns/20220916-shijianchen-note.png"
          alt=""
        /> -->
            <img
              class="note-lf"
              src="https://source.qunarzz.com/site/images/wns/20220919-shijianchen-note.jpg"
              alt=""
            />
            <div class="note-rt">
              <div class="note-box">
                <img
                  class="note-logo"
                  src="https://source.qunarzz.com/site/images/wns/20220919-shijianchen-logo.jpg"
                  alt=""
                />
                <div>
                  <div class="undeline">
                    踏上一场滇南野奢之旅——解锁腾冲宝藏路线
                  </div>
                  <p>@Rocky哥看世界</p>
                </div>
              </div>
            </div>
          </a>
        </mt-swipe-item>
        <mt-swipe-item>
          <div class="video3">
            <videoComp
              :type="'nobg'"
              poster="https://source.qunarzz.com/site/images/wns/20221009-shijianchen-vol-1-poster.png"
              src="https://source.qunarzz.com/site/images/wns/20221009-shijianchen-vol-1.mp4"
            ></videoComp>
          </div>
          <a
            v-maidian="'note'"
            class="note"
            href="http://travel.qunar.com/travelbook/note/7754681"
          >
            <!-- <img
          src="https://source.qunarzz.com/site/images/wns/20220916-shijianchen-note.png"
          alt=""
        /> -->
            <img
              class="note-lf"
              src="https://source.qunarzz.com/site/images/wns/20220929-shijianchen-vol1.png"
              alt=""
            />
            <div class="note-rt">
              <div class="note-box">
                <img
                  class="note-logo"
                  src="https://source.qunarzz.com/site/images/wns/20220929-shijianchen-logo.png"
                  alt=""
                />
                <div>
                  <div class="undeline">
                    极边慢生活，驭见地貌奇观与梦幻画卷
                  </div>
                  <p>@秦鹏P的话</p>
                </div>
              </div>
            </div>
          </a>
        </mt-swipe-item>
      </mt-swipe>
    </div>
    <div class="bottom"></div>
  </div>
</template>
<script>
import banner from './components/banner.vue';
import appoint from './components/appoint.vue';
import wondalful from './components/wondalful.vue';
import gotomini from './components/gotomini.vue';
import videoComp from './components/video.vue';
import lineComp from './components/line.vue';
export default {
  components: {
    banner,
    appoint,
    wondalful,
    gotomini,
    videoComp,
    lineComp,
  },
  data() {
    return {
      lookMore: false,
      lineList1: [
        [
          {
            headImg:
              'https://img1.qunarzz.com/vs_ceph_b2c_001/93673544-b4cf-4f0f-996f-2269f57f38a0.jpg_r_640x420x95_20cec8f8.jpg',
            tagList: ['雪山温泉', '草原'],
            price: 8900,
            tag: '服务贴心/早餐很赞',
            desc: '【沃尔沃心选路线】北海湿地+火山地热国家公园丨如画边陲',
            descList: [
              '·行走极边之城，感受森林秘境',
              '·观星空享私汤，品特色私房菜',
              '·腾冲热海丨高黎贡山丨和顺古镇',
            ],
            linkId: 'https://touch.dujia.qunar.com/p/item/1919867252',
            discountId: '1678403036',
          },
        ],
      ],
      lineList2: [
        [
          {
            headImg:
              'https://img1.qunarzz.com/vs_ceph_b2c_001/5d9a634b-9ed4-40dc-83a8-12b5fe827bf0.jpg_r_640x420x95_207e8877.jpg',
            tagList: ['雪山温泉', '草原'],
            price: 19600,
            tag: '服务贴心/早餐很赞',
            desc: '【沃尔沃心选路线】赛里木湖+空中草原丨穿越童话森林',
            descList: [
              '·人间仙境的自驾乐土',
              '·赏万亩紫色花田，品异域风情美食',
              '·赛里木湖丨夏塔古道丨醉情北疆风光',
            ],
            linkId: 'https://touch.dujia.qunar.com/p/item/1951227822',
            discountId: '1678403036',
          },
          {
            headImg:
              'https://img1.qunarzz.com/vs_ceph_b2c_001/0241d032-bd80-4288-b725-b1a2859b71b1.jpg_r_640x420x95_cbfd1694.jpg',

            tagList: ['海鲜自助', '海岛游'],
            price: 22000,
            desc: '【沃尔沃心选路线】茶卡盐湖+敦煌莫高窟丨邂逅绮丽大漠',
            descList: [
              '·千里黄沙下的奇观与遗迹',
              '·有趣多变住宿体验，寻味西域美食',
              '·青海湖丨魔鬼城丨遍赏绮丽大漠',
            ],
            tag: '环境舒适/客房干净',
            linkId: 'https://touch.dujia.qunar.com/p/item/1930671498',
            discountId: '3770793980',
          },
          {
            headImg:
              'https://img1.qunarzz.com/vs_ceph_b2c_001/f6600915-d1f5-4b97-9978-9f5d460086e9.jpg_r_640x420x95_49f1b322.jpg',

            tagList: ['海鲜自助', '海岛游'],
            price: 11600,
            desc: '【沃尔沃心选路线】昆仑山+可可西里+火星营地丨探寻海西秘境',
            descList: [
              '·步戈壁旷野，感受地质变迁',
              '·火星营地奇妙夜，观浪漫星河',
              '·昆仑山口丨可可西里丨远古传奇地',
            ],
            tag: '房间干净/环境舒适',
            linkId: 'https://touch.dujia.qunar.com/p/item/664076878',
            discountId: '3770793980',
          },
          {
            headImg:
              'https://img1.qunarzz.com/vs_ceph_b2c_001/3423e207-b057-4e70-b9d7-b2a3903ea530.jpg_r_640x420x95_9c9f5060.jpg',
            tagList: ['雪山温泉', '草原'],
            price: 11950,
            descList: [
              '·黔地南行，感受自然鬼斧神工',
              '·宿于青山秀水，尝贵州特色美食',
              '·苗族村寨丨长桌宴丨探寻民族风情',
            ],
            desc: '【沃尔沃心选路线】郎德上寨+黄果树瀑布丨探秘黔南绿野仙踪',
            tag: '位置优越/风景优美',
            linkId: 'https://touch.dujia.qunar.com/p/item/796394676',
            discountId: '1678403036',
          },
          {
            headImg:
              'https://img1.qunarzz.com/vs_ceph_b2c_001/f3eabe50-8141-4e3b-ae94-d8c0d9495689.jpg_r_640x420x95_ac21b59d.jpg',
            tagList: ['雪山温泉', '草原'],
            price: 17660,
            descList: [
              '·入百越大地，赏山水明珠',
              '·高奢阳朔悦榕庄，丰富湘粤桂美食',
              '·遇龙河丨芦笛岩丨悠然泛舟漓江上',
            ],
            desc: '【沃尔沃心选路线】十里画廊+龙脊梯田丨溯漓江探瑰丽百越',
            tag: '位置优越/风景优美',
            linkId: 'https://touch.dujia.qunar.com/p/item/423484012',
            discountId: '1678403036',
          },
          {
            headImg:
              'https://img1.qunarzz.com/vs_ceph_b2c_001/e9b72002-8e26-4c90-9681-8f902c3f0ade.jpg_r_640x420x95_ba8d4ca9.jpg',
            tagList: ['雪山温泉', '草原'],
            price: 9699,
            descList: [
              '·聆千年梵音，观人间银河',
              '·禅意自然山居，黑珍珠三钻美食',
              '·国清寺丨琼台仙谷 丨寻回内心清净',
            ],
            desc: '【沃尔沃心选路线】天台山+国清寺+琼台仙谷丨隐逸世外佛国',
            tag: '位置优越/风景优美',
            linkId: 'https://touch.dujia.qunar.com/p/item/2371819774',
            discountId: '1678403036',
          },
          {
            headImg:
              'https://img1.qunarzz.com/vs_ceph_b2c_001/4c41a719-7c95-4ee2-ae64-8550eab60351.jpg_r_640x420x95_3d91b6bc.jpg',
            tagList: ['雪山温泉', '草原'],
            price: 5899,
            descList: [
              '·走进梦幻海景，沉浸向往生活',
              '·五星级白沙滩海景房，享新鲜海味',
              '·惠州西湖丨海龟湾丨坐拥十里银滩',
            ],
            desc: '【沃尔沃心选路线】惠州西湖+海龟湾+十里银滩丨诗意海岛梦',
            tag: '位置优越/风景优美',
            linkId: 'https://touch.dujia.qunar.com/p/item/3422706323',
            discountId: '1678403036',
          },
          {
            headImg:
              'https://img1.qunarzz.com/vs_ceph_b2c_001/0f990ff8-f73e-4d9f-82b2-0418f83a5835.jpg_r_640x420x95_19ffc4b8.jpg',
            tagList: ['雪山温泉', '草原'],
            price: 7230,
            descList: [
              '·听岷江流水，寻川蜀仙境',
              '·归隐山间六善酒店，品蜀地美食',
              '·青城山丨都江堰  饱览仙境山水',
            ],
            desc: '【沃尔沃心选路线】青城山+都江堰丨岷水江畔寻源道教',
            tag: '位置优越/风景优美',
            linkId: 'https://touch.dujia.qunar.com/p/item/4066072266',
            discountId: '1678403036',
          },
          {
            headImg:
              'https://img1.qunarzz.com/vs_ceph_b2c_001/c944652e-aa71-4943-ad1f-b3e9b9bba629.jpg_r_640x420x95_276954aa.jpg',
            tagList: ['雪山温泉', '草原'],
            price: 4599,
            descList: [
              '·早知有蓟州，何必下江南',
              '·野奢山居民宿，品尝醇厚农家美味',
              '·梨木台丨天然溶洞丨私享山林野趣',
            ],
            desc: '【沃尔沃心选路线】独乐寺+梨木台+蓟州溶洞丨寻梦蓟州桃花源',
            tag: '位置优越/风景优美',
            linkId: 'https://touch.dujia.qunar.com/p/item/2454979376',
            discountId: '1678403036',
          },
        ],
      ],
      imgs: [
        'https://source.qunarzz.com/site/images/wns/20220916-shijianchen-lun1.png',
        'https://source.qunarzz.com/site/images/wns/20220916-shijianchen-lun2.png',
        'https://source.qunarzz.com/site/images/wns/20220919-shijianchen-ll5.jpeg',
        'https://source.qunarzz.com/site/images/wns/20220916-shijianchen-lun4.png',
        'https://source.qunarzz.com/site/images/wns/20220916-shijianchen-lun5.png',
        'https://source.qunarzz.com/site/images/wns/20220920-shijianchen-lun1.jpeg',
      ],
      imgs2: [
        'https://source.qunarzz.com/site/images/wns/20220916-shijianchen-ll1.png',
        'https://source.qunarzz.com/site/images/wns/20220916-shijianchen-ll2.png',
        'https://source.qunarzz.com/site/images/wns/20220916-shijianchen-ll3.png',
        'https://source.qunarzz.com/site/images/wns/20220919-shijianchen-ll2.png',
      ],
      currentIndex: 1,
      currentIndex2: 1,
      lineList: [
        {
          src: 'https://source.qunarzz.com/site/images/wns/20220713-shijianchen-line1.png',
          href: 'https://touch.dujia.qunar.com/p/item/1448117054',
        },
        {
          src: 'https://source.qunarzz.com/site/images/wns/20220713-shijianchen-line2.png',
          href: 'https://touch.dujia.qunar.com/p/item/4194680827',
        },
        {
          src: 'https://source.qunarzz.com/site/images/wns/20220713-shijianchen-line3.png',
          href: 'https://touch.dujia.qunar.com/p/item/3870844526',
        },
        {
          src: 'https://source.qunarzz.com/site/images/wns/20220713-shijianchen-line4.png',
          href: 'https://touch.dujia.qunar.com/p/item/397136718',
        },
        {
          src: 'https://source.qunarzz.com/site/images/wns/20220713-shijianchen-line5.png',
          href: 'https://touch.dujia.qunar.com/p/item/3634953914',
        },
        {
          src: 'https://source.qunarzz.com/site/images/wns/20220713-shijianchen-line6.png',
          href: 'https://touch.dujia.qunar.com/p/item/3210886155',
        },
        {
          src: 'https://source.qunarzz.com/site/images/wns/20220713-shijianchen-line7.png',
          href: 'https://touch.dujia.qunar.com/p/item/3057685775',
        },
        {
          src: 'https://source.qunarzz.com/site/images/wns/20220713-shijianchen-line8.png',
          href: 'https://touch.dujia.qunar.com/p/item/2363130307',
        },
        {
          src: 'https://source.qunarzz.com/site/images/wns/20220713-shijianchen-line9.png',
          href: 'https://touch.dujia.qunar.com/p/item/2719514383',
        },
      ],
    };
  },
  mounted() {
    var vm = this;
    var swiper = new Swiper('.swiper-container', {
      autoplay: {
        delay: 3000, //1秒切换一次
      },
      slidesPerView: 3,
      spaceBetween: 30,
      centeredSlides: true,
      loop: true,
    });
    new Swiper('.swiper-container2', {
      autoplay: {
        delay: 3000, //1秒切换一次
      },
      loop: true,
    });
  },
  methods: {
    prev: function () {
      this.$refs.swipeWrapper.prev();
    },
    next: function () {
      this.$refs.swipeWrapper.next();
    },
    goAppoint() {
      window.scrollTo(0, document.querySelector('#appont-fluid').offsetTop);
    },
    jump() {
      this.$router.push({
        path: '/volvo07Activity',
      });
    },
  },
};
</script>
<style lang='less' scoped='true'>
.top {
  height: 965px;
  background: url(https://source.qunarzz.com/site/images/wns/20220915-shijianchen-1.jpg)
    no-repeat;
  background-size: 100% auto;
  overflow-x: hidden;
  position: relative;
  .route {
    position: absolute;
    bottom: 28px;
    width: calc(100% - 36px);
    left: 18px;
  }
}
.top-f1 {
  position: absolute;
  left: 50%;
  width: 180px;
  transform: translateX(-50%);
  top: 263px;
}
#main {
  background-color: #dbdbdb;
  position: relative;
  overflow-x: hidden;
  overflow-y: auto;
}
.center {
  position: relative;
  padding-top: 20px;
  min-height: 1800px;
  &:after {
    content: '';
    display: block;
    width: 100%;
    top: 0;
    position: absolute;
    height: 1800px;
    background: url(https://source.qunarzz.com/site/images/wns/20220915-shijianchen-3.jpg)
      no-repeat;
    background-size: 100% auto;
  }
  .special {
    margin-top: 100px;
    height: 150px;
    .swiper-container {
      width: 700px;
      transform: translateX(-50%);
      position: relative;
      left: 50%;
      margin-top: -90px;
      overflow: inherit;
    }
    .swiper-slide {
      text-align: center;
      font-size: 18px;
      background: #fff;

      /* Center slide text vertically */
      display: -webkit-box;
      display: -ms-flexbox;
      display: -webkit-flex;
      display: flex;
      -webkit-box-pack: center;
      -ms-flex-pack: center;
      -webkit-justify-content: center;
      justify-content: center;
      -webkit-box-align: center;
      -ms-flex-align: center;
      -webkit-align-items: center;
      align-items: center;
      transition: 300ms;
      transform: scale(0.8);
    }
    .swiper-slide-active,
    .swiper-slide-duplicate-active {
      transform: scale(1.3);
      border: 2px solid #fff;
      border-radius: 6px;
      overflow: hidden;
      img {
        border-radius: 6px;
      }
    }
  }
}
.left,
.right {
  position: absolute;
  top: 90px;
  width: 8px;
  z-index: 200;
}
.left {
  left: 40px;
}
.right {
  right: 40px;
}
.swipeWrapper {
  height: 350px;
}
.video {
  position: absolute;
  z-index: 2;
  width: 327px;
  top: 350px;
  left: 50%;
  height: 184px;
  // background-color: #000;
  transform: translateX(-50%);
  #video001 {
    height: 100%;
  }
  video {
    height: 100%;
  }
}
.video2 {
  width: 327px;
  height: 200px;
  img {
    height: 200px;
    border-radius: 10px;
  }
  margin-left: auto;
  margin-right: auto;
  overflow: hidden;
  position: relative;
  z-index: 2;
  border-radius: 6px;
  margin-top: 260px;
}
.video3 {
  width: 327px;
  height: 184px;
  margin-left: auto;
  margin-right: auto;
  overflow: hidden;
  position: relative;
  z-index: 2;
  border-radius: 6px;
  border: 1px solid #fff;
}
.note1 {
  width: 327px;
  margin-top: 7px;
  margin-left: auto;
  margin-right: auto;
  border-radius: 12px;
  overflow: hidden;
}
.lineTop {
  margin-top: 703px;
  padding-bottom: 10px;
}
.box {
  position: relative;
  z-index: 2;
}
.box {
  .line {
    margin-top: 15px;
    &:nth-child(2) {
      margin-top: 0;
    }
  }
}
.tit {
  position: relative;
  z-index: 2;
  display: block;
  width: calc(100% - 38px);
  margin-left: auto;
  margin-right: auto;
  margin-top: 15px;
  margin-bottom: 29px;
}
.note {
  width: calc(100% - 48px);
  height: 100px;
  background: url(https://source.qunarzz.com/site/images/wns/20220801-shijianchen-vol-bg.png)
    no-repeat;
  background-size: 100% 100%;
  display: flex;
  margin: 20px auto 0;
  text-decoration: none;
  text-align: left;
  color: inherit;
  border-radius: 12px;
  overflow: hidden;
  .note-lf {
    width: 156px;
  }
}
.lineList1 {
  position: relative;
  left: 0;
  margin-top: 375px;
  width: 100%;
}
.bottom {
    background: url(https://source.qunarzz.com/site/images/wns/20220916-shijianchen-4.jpg) no-repeat;
    background-size: 100% auto;
    height: 257px;
    background-position-y: -1117px;
}
.note-rt {
  width: calc(100% - 163px);
  margin-left: 5px;
  display: flex;
  align-items: center;
  .note-logo {
    width: 40px;
    height: 40px;
    border-radius: 50%;
  }
  .note-box {
    display: flex;
    font-size: 12px;
    > div {
      width: calc(100% - 45px);
      margin-left: 5px;
    }
    .undeline {
      text-decoration: underline;
    }
    p {
      text-align: right;
      text-decoration: none;
      padding-right: 10px;
      margin-top: 6px;
    }
  }
}
</style>